import {TRACK_DATA_CONSTANTS} from '@/constants';
import {desktopSize} from '@/hooks/WindowSize/models/constants';
import {WebViewService} from '@/services/webview/WebViewService';

interface DeviceInfo {
  Device_info: {
    source: string;
    browser: string;
    isWebView: boolean;
  };
}

export const getDeviceInfo = () => {
  return transformDeviceInfoToDeviceSchema(navigator.userAgent);
};

const transformDeviceInfoToDeviceSchema = (browser: string): DeviceInfo => {
  return {
    Device_info: {
      source:
        window.innerWidth <= desktopSize
          ? TRACK_DATA_CONSTANTS.MOBILE
          : TRACK_DATA_CONSTANTS.SOURCE,
      browser,
      isWebView: WebViewService.isWebViewActive(),
    },
  };
};
